<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 100 100">

  <g>
    <path d="M50,0C22.39,0,0,23,0,51.27,0,73.92,14.33,93.13,34.19,99.91c2.5.48,3.42-1.11,3.42-2.46s0-5.27-.07-9.55C23.63,91,20.7,81.85,20.7,81.85c-2.28-5.92-5.56-7.5-5.56-7.5-4.53-3.18.35-3.12.35-3.12,5,.37,7.66,5.29,7.66,5.29,4.46,7.83,11.7,5.57,14.55,4.26a11.05,11.05,0,0,1,3.18-6.86C29.77,72.63,18.1,68.23,18.1,48.59a20.11,20.11,0,0,1,5.15-13.76c-.52-1.29-2.23-6.51.48-13.57,0,0,4.2-1.38,13.75,5.26a46.2,46.2,0,0,1,25.05,0c9.54-6.64,13.73-5.26,13.73-5.26,2.72,7.06,1,12.28.49,13.57A20.06,20.06,0,0,1,81.9,48.59c0,19.69-11.7,24-22.83,25.29,1.79,1.59,3.39,4.71,3.39,9.5,0,6.86-.06,12.38-.06,14.07,0,1.36.9,3,3.44,2.46C85.69,93.12,100,73.91,100,51.27,100,23,77.61,0,50,0Z"/>
    <path d="M17.63,73c-.12.26.09.61.45.77a.62.62,0,0,0,.86-.15c.12-.26-.08-.61-.45-.78S17.74,72.73,17.63,73Z"/>
    <path d="M19.8,74.62a.79.79,0,0,0,.14,1.07c.32.35.78.46,1,.23s.19-.7-.14-1.06S20,74.39,19.8,74.62Z"/>
    <path d="M21.82,77.21a.9.9,0,0,0,0,1.22c.31.46.81.66,1.11.44s.32-.77,0-1.23S22.13,77,21.82,77.21Z"/>
    <path d="M24.07,80.22a1,1,0,0,0,.28,1.31c.43.42,1,.51,1.29.2s.16-.9-.28-1.31S24.34,79.91,24.07,80.22Z"/>
    <path d="M27.29,82.75c-.11.4.26.87.82,1s1.13,0,1.25-.42-.25-.87-.82-1S27.41,82.34,27.29,82.75Z"/>
    <path d="M31.3,83.73c0,.41.49.76,1.09.74s1.08-.36,1.06-.78-.48-.76-1.08-.75S31.3,83.3,31.3,83.73Z"/>
    <path d="M36.07,82.46c-.58.11-1,.54-.93,1s.61.66,1.19.55,1-.53.93-.94S36.66,82.36,36.07,82.46Z"/>
  </g>
</svg>

</template>

<script>
export default {
  name: 'github-mark',
  props: {
    size: {
      type: Number,
      default: 50,
    },
  },
  components: {},
  data () {
    return {}
  }
}
</script>

<style scoped lang="sass">
path
  fill: black
  @media screen and (prefers-color-scheme: dark)
    fill: white

</style>
